import { publicEnv } from '~/features/environment/public';

import { SemanticType } from '../models/program';

export function getClassroomUrl(programKey: string, semanticType: SemanticType) {
  if (semanticType === 'Degree') {
    return `${publicEnv.NEXT_PUBLIC_LEARN_URL}/nanodegrees/${programKey}/resume-learning`;
  } else if (semanticType === 'Part') {
    return `${publicEnv.NEXT_PUBLIC_LEARN_URL}/paid-courses/${programKey}/resume-learning`;
  } else {
    return `${publicEnv.NEXT_PUBLIC_LEARN_URL}/courses/${programKey}/resume-learning`;
  }
}
